import { Component, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import {
  TypeOfWine,
  WineCharacter,
  WineColor,
  WineCountry,
  WineLandscapeUnitAbroad,
  WineLandscapeUnitHun,
  WineRegion,
  WineSweetness,
} from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { GrapeWineProperties } from '@app/api/models';

@Component({
  selector: 'app-grape-wine-properties-subform',
  templateUrl: './grape-wine-properties-subform.component.html',
  styleUrls: ['./grape-wine-properties-subform.component.scss'],
})
export class GrapeWinePropertiesSubformComponent
  extends SubformBaseComponent
  implements AfterViewInit
{
  DICT_PATH = 'PRODUCTS.GRAPE_WINE_PROPERTIES';

  wineColor = WineColor;
  wineSweetness = WineSweetness;
  typeOfWine = TypeOfWine;
  characters = WineCharacter;
  wineRegion = WineRegion;
  wineLandscapeUnitHun = WineLandscapeUnitHun;
  wineCountry = WineCountry;
  wineLandscapeUnitAbroad = WineLandscapeUnitAbroad;

  static buildForm(
    fb: FormBuilder,
    data: GrapeWineProperties | undefined,
    isSecondaryProductSheet: boolean
  ) {
    return fb.group({
      year: [
        data?.year,
        [
          Validators.required,
          Validators.min(1980),
          Validators.max(new Date().getFullYear()),
        ],
      ],
      wineColor: [data?.wineColor, Validators.required],
      wineSweetness: [data?.wineSweetness, Validators.required],
      typeOfWine: [data?.typeOfWine, Validators.required],

      ...(!isSecondaryProductSheet && {
        characters: [data?.characters, Validators.required],
      }),

      // HUNGARY
      wineLandscapeUnitHun: [data?.wineLandscapeUnitHun, Validators.required],

      // ABROAD
      wineLandscapeUnitAbroad: [
        data?.wineLandscapeUnitAbroad,
        Validators.required,
      ],

      ...(data?.wineLandscapeUnitAbroad === WineLandscapeUnitAbroad.Other && {
        otherWineLandscapeUnitAbroad: [data?.otherWineLandscapeUnitAbroad],
      }),
    });
  }

  ngAfterViewInit(): void {
    if (this.group.get('wineLandscapeUnitAbroad')?.value) {
      this.group.get('wineLandscapeUnitHun')?.disable();
    }
    if (this.group.get('wineLandscapeUnitHun')?.value) {
      this.group.get('wineLandscapeUnitAbroad')?.disable();
    }
  }

  onLandscapeUnitAbroadSelected(selected: WineLandscapeUnitAbroad) {
    if (selected === WineLandscapeUnitAbroad.Other) {
      this.group.addControl(
        'otherWineLandscapeUnitAbroad',
        this.fb.control(null)
      );
    } else {
      this.rmCtrl('otherWineLandscapeUnitAbroad');
    }

    if (selected) {
      this.group.addControl(
        'wineRegion',
        this.fb.control('ABROAD', Validators.required)
      );
      this.group.get('wineLandscapeUnitHun')?.clearValidators();
      this.group
        .get('wineLandscapeUnitHun')
        ?.setValue('', { emitEvent: false });
      this.group.get('wineLandscapeUnitHun')?.disable({ emitEvent: false });
    } else {
      this.rmCtrl('wineRegion');
      this.group
        .get('wineLandscapeUnitHun')
        ?.setValidators(Validators.required);
      this.group.get('wineLandscapeUnitHun')?.enable({ emitEvent: false });
    }
  }

  onLandscapeUnitHunSelected(selected: WineLandscapeUnitHun) {
    if (selected) {
      this.group.addControl(
        'wineRegion',
        this.fb.control('HUNGARY', Validators.required)
      );
      this.group.get('wineLandscapeUnitAbroad')?.clearValidators();
      this.group
        .get('wineLandscapeUnitAbroad')
        ?.setValue('', { emitEvent: false });
      this.group.get('wineLandscapeUnitAbroad')?.disable({ emitEvent: false });
    } else {
      this.rmCtrl('wineRegion');
      this.group
        .get('wineLandscapeUnitAbroad')
        ?.setValidators(Validators.required);
      this.group.get('wineLandscapeUnitAbroad')?.enable({ emitEvent: false });
    }
  }

  get currentYear() {
    return new Date().getFullYear();
  }
}
